import type { AlgoliaCompanyRecord } from '../../types/algolia-company-record';

/**
 * Derives hub list + loading flag from SSR-resolved companies and optional client fetch.
 * Used by {@link useBestCompaniesHubClientCompanies} so behaviour stays easy to unit test.
 */
export function computeBestCompaniesHubClientDisplay(
  resolvedCompanies: AlgoliaCompanyRecord[],
  fetched: AlgoliaCompanyRecord[] | null,
  clientFetchFinished: boolean,
  isBrowser: boolean,
): { companies: AlgoliaCompanyRecord[]; isLoadingHubCompanies: boolean } {
  if (resolvedCompanies.length > 0) {
    return { companies: resolvedCompanies, isLoadingHubCompanies: false };
  }

  const companies = fetched ?? [];
  return {
    companies,
    isLoadingHubCompanies: isBrowser && !clientFetchFinished,
  };
}
